"use strict";

class Globals {
    static colors = {
        body: "#697a8d",
        danger: "#e6381a",
    };
}

export default Globals;
